import { SovosBox, SovosButton, SovosTypography } from "mosaic-react";
import React from "react";
import InlineLoadError from "../InlineLoadError";
import ChooseEntityPageSection from "./ChooseEntityPageSection";
import EntityAutocompleteField from "./EntityAutocompleteField";
import MapByAiButton from "./MapByAiButton";

const MapEntitySection = ({
    aiEntityError,
    aiEntityScore,
    aiEntityWarnings,
    entities,
    entityError,
    selectionKey,
    i18n,
    initialEntityName,
    initialFileType,
    loadingAiEntity,
    loadingEntities,
    noMappableEntities,
    onRetryEntities,
    onRetryPreload,
    onSelectEntity,
    onSuggestEntity,
    preloadError,
    selectedStructureLabel,
    suggestionScores,
    unresolved,
    unresolvedEntityName,
    onReloadContexts,
}) => {
    const aiFeedbackMessages = aiEntityError ? [aiEntityError] : aiEntityWarnings;

    return (
        <ChooseEntityPageSection
            description={i18n`You are uploading data in a new format. To proceed with the upload, select which entity this data maps to.`}
            title={i18n`Map entity`}
        >
            <EntityAutocompleteField
                aiEntityScore={aiEntityScore}
                disabled={loadingEntities || entityError || noMappableEntities}
                entities={entities}
                i18n={i18n}
                loading={loadingEntities}
                onChange={onSelectEntity}
                suggestionScores={suggestionScores}
                value={selectionKey}
            />
            {entityError && !loadingAiEntity && !aiEntityError && (
                <InlineLoadError i18n={i18n} onRetry={onRetryEntities} />
            )}
            {preloadError && <InlineLoadError i18n={i18n} onRetry={onRetryPreload} />}
            {noMappableEntities && (
                <SovosTypography role="status" color="text.secondary" variant="caption">
                    {i18n`No mappable entities are configured for ${selectedStructureLabel || ""}`}
                </SovosTypography>
            )}
            {unresolved && (
                <SovosBox role="alert" sx={{ mb: 2 }}>
                    <SovosTypography color="warning.dark" variant="caption">
                        {i18n`The saved mapping configuration could not be resolved.`}
                    </SovosTypography>
                    <SovosTypography variant="caption">
                        {`${unresolvedEntityName || initialEntityName} (${initialFileType})`}
                    </SovosTypography>
                    <SovosButton onClick={onReloadContexts} size="small" variant="text">
                        {i18n`Retry`}
                    </SovosButton>
                </SovosBox>
            )}

            {onSuggestEntity && (
                <SovosBox sx={{ mb: 1.5, mt: 1 }}>
                    <MapByAiButton
                        disabled={!entities.length || noMappableEntities}
                        i18n={i18n}
                        loading={loadingAiEntity}
                        onClick={onSuggestEntity}
                    />
                    {aiFeedbackMessages.length > 0 && (
                        <SovosBox
                            role="alert"
                            sx={{ bgcolor: "warning.light", borderRadius: 1, mt: 0.75, p: 1 }}
                        >
                            {aiFeedbackMessages.map((message) => (
                                <SovosTypography key={message} color="warning.dark" variant="caption">
                                    {message}
                                </SovosTypography>
                            ))}
                        </SovosBox>
                    )}
                </SovosBox>
            )}
        </ChooseEntityPageSection>
    );
};

export default MapEntitySection;
